module.exports = __webpack_public_path__ + "img/education.d0b111ca.svg";